var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIpfsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new"
    },
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    viewBox: "0 0 511.99999 511.99998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y2: 771.51,
    gradientUnits: "userSpaceOnUse",
    y1: 771.51,
    x2: 527.72,
    x1: 84.315
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4a9ea1",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    y2: 771.48,
    gradientUnits: "userSpaceOnUse",
    y1: 771.48,
    x2: 512.36,
    x1: 99.675
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63d3d7",
    offset: 0
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    },
    transform: "translate(-50.017,-515.51)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m84.315 899.51 221.7 128 221.7-128v-256l-221.7-127.99-221.7 128z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m283.13 546.35-160.74 92.806c0.32126 2.8543 0.32125 5.7352 0 8.5894l160.75 92.806c13.554-10.001 32.043-10.001 45.597 0l160.75-92.807c-0.32126-2.8543-0.32293-5.7338-0.001-8.588l-160.74-92.806c-13.554 10.001-32.044 10.001-45.599 0zm221.79 127.03-160.92 93.84c1.884 16.739-7.3611 32.751-22.799 39.489l0.18062 184.58c2.6325 1.1489 5.1267 2.5886 7.438 4.294l160.75-92.805c-1.884-16.739 7.3611-32.752 22.799-39.49v-185.61c-2.6325-1.1489-5.1281-2.5886-7.4394-4.294zm-397.81 1.0315c-2.3112 1.7054-4.8054 3.1465-7.438 4.2954v185.61c15.438 6.7378 24.683 22.75 22.799 39.489l160.74 92.806c2.3112-1.7054 4.8069-3.1465 7.4394-4.2954v-185.61c-15.438-6.7378-24.683-22.75-22.799-39.489l-160.74-92.81z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    },
    transform: "translate(0,-196.66)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25098,
    d: "m256 708.66 221.7-128v-256l-221.7 128v256z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.039216,
    d: "m256 708.66v-256l-221.7-128v256l221.7 128z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.13018,
    d: "m34.298 324.66 221.7 128 221.7-128-221.7-128-221.7 128z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    },
    fill: "#fff"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m103.09 186h-29.2v141.2h29.2v-141.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m153.97 327.2v-51.8c7.2 0.6 14.4 0.6 20.4 0.6 41.6 0 53.6-20.6 53.6-46 0-30.8-22-44-56-44h-47.2v141.2h29.2zm15.8-71.8c-5.4 0-13.4 0-15.8-0.2v-48h18.2c17.6 0 27.6 8.4 27.6 23.8v0.4c0 12-4.4 24-30 24z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m327.95 186h-88.6v141.2h29.2v-62.2h55.4v-21.2h-55.6v-36.4h57.6l2-21.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m423.51 213.6 7.6-19.6c-11.4-8.2-26.8-11.2-46.2-11.2-28.2 0-51.4 13.2-51.4 40.2 0 24.2 17.8 33.8 35.6 39.6l17.8 6c12.2 4.2 22.2 8.2 22.2 21.4 0 12-10.4 16.8-26.2 16.8-16 0-33.2-4.8-43-11l-7.6 21.2c12.8 8.2 29 12.2 50.8 12.2 31 0 55-13.6 55-42.6 0-27-20.6-35.6-41.4-42.6l-19.4-6.4c-8.4-2.8-14.8-6.6-14.8-17.4 0-11 9-15.4 22.4-15.4 16.4 0 29.2 3 38.6 8.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpfsIcon);
export default __webpack_public_path__ + "static/media/ipfsIcon.e72ed017e544de087a891a7168a70cb7.svg";
export { ForwardRef as ReactComponent };